module.exports = __webpack_public_path__ + "img/american_express.5645420f.png";